// src/pages/Concierge/Concierge.jsx
import React from "react";
import ConciergeHeader from "./ConciergeComponents/ConciergeHeader";
import ConciergeUpper from "./ConciergeComponents/ConciergeUpper";
// ⬇️ 하단 스텝 컴포넌트 파일명이 다르면 경로/이름만 맞춰주세요.
import ConciergeStep from "./ConciergeComponents/ConciergeStep";

export default function Concierge({

}) {

  const handleStart = () => {
    const el = document.getElementById("concierge-steps");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <main>
      {/* 상단 소개 섹션 */}
      <section id="concierge-upper" className="w-full ">
        <ConciergeHeader onClickStart={handleStart} />
      </section>

      <section id="concierge-upper" className="w-full bg-white">
        <ConciergeUpper />
      </section>



      {/* 하단 스텝 섹션 */}
      <section id="concierge-steps" className="w-full bg-[#F5F6F9] py-8">
        <ConciergeStep />
      </section>
    </main>
  );
}
